import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';
import { credentialInstructions, getProviderFormLabel } from '../utils';
import NoticeMessage from 'pages/Authorize/Messages/Notice';
import { Box } from '@chakra-ui/react';

export function SignInAdpRunCredential({
  isLoading,
  onSubmit,
  client,
  provider,
  instructionsLink,
}: RegisterImplementationProps) {
  const instructions = credentialInstructions(client);

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      instructionsLink={instructionsLink}
      onSubmit={onSubmit}
      fieldNames={['username', 'password']}
      render={({ username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Box pb="1px">
                <NoticeMessage>
                  Please ensure you are assigned the Owner role in your ADP Run
                  account so that a third-party admin can be added.
                </NoticeMessage>
              </Box>
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="User ID"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://runpayroll.adp.com/'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={isLoading || !username.value || !password.value}
              type="submit"
            />
          </>
        );
      }}
    />
  );
}
